import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BankStatementRuleJointTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.joint.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { BankStatementRuleJointTypeNamePipe } from '@zaoblako/web/shared/pipes/bank-statement-rule-joint-type-name.pipe';

@Component({
  selector: 'crm-bank-statement-rule-joint-type-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, BankStatementRuleJointTypeNamePipe],
  templateUrl: './bank-statement-rule-joint-type-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankStatementRuleJointTypeSingleSelectComponent {
  @Input() public type: BankStatementRuleJointTypeEnum;
  @Output() public typeChange = new EventEmitter<BankStatementRuleJointTypeEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: any;

  public options = Object.values(BankStatementRuleJointTypeEnum);
}
